<div adaptToolbarContent>
    <button *adaptIfAuthorised="'manageAccess'"
            adaptButton="add"
            [adaptBlockingClick]="inviteUser"
            data-test="add-employee-button"> employee</button>
</div>

<adapt-people-grid></adapt-people-grid>
